import * as React from 'react'
import { FluentIconsProps, wrapIcon } from '@fluentui/react-icons'
import { makeStyles } from '@fluentui/react-components'

const useStyles = makeStyles({
    st0: { fill: '#21A365' },
    st1: { fill: '#107C41' },
    st2: { fill: '#185B37' },
    st3: { fill: '#33C481' },
    st4: { fill: '#17864C' },
    st5: { fill: '#FFFFFF' },
    st6: { fill: '#036C70' },
    st7: { fill: '#1A9BA1' },
    st8: { fill: '#37C6D0' },
    st9: { fill: '#04878B' },
    st10: { fill: '#4F59CA' },
    st11: { fill: '#7B82EA' },
    st12: { fill: '#4C53BB' },
    st13: { fill: '#0F78D5' },
    st14: { fill: '#29A7EB' },
    st15: { fill: '#0358A8' },
    st16: { fill: '#0F79D6' },
    st17: { fill: '#038387' },
    st18: { fill: '#048A8E' },
    st19: { fill: '#C8421D' },
    st20: { fill: '#FF8F6A' },
    st21: { fill: '#ED6B47' },
    st22: { fill: '#891323' },
    st23: { fill: '#AF2131' },
    st24: { fill: '#C94E60' },
    st25: { fill: '#E08195' },
    st26: { fill: '#B42839' },
    st27: { fill: '#0464B8' },
    st28: { fill: '#0377D4' },
    st29: { fill: '#4FD8FF' },
    st30: { fill: '#1681D7' },
    st31: { fill: '#0178D4' },
    st32: { fill: '#042071' },
    st33: { fill: '#168FDE' },
    st34: { fill: '#CA64EA' },
    st35: { fill: '#7E1FAF' },
    st36: { fill: '#AE4BD5' },
    st37: { fill: '#9332BF' },
    st38: { fill: '#7719AA' },
    st39: { fill: '#0078D4' },
    st40: { fill: '#1490DF' },
    st41: { fill: '#0364B8' },
    st42: { fill: '#28A8EA' },
    st43: { fill: '#41A5ED' },
    st44: { fill: '#2C7BD5' },
    st45: { fill: '#195ABE' },
    st46: { fill: '#103E91' },
    st47: { fill: '#2166C3' },
    st48: { opacity: 0.2 },
})

export const SharePointIcon = wrapIcon((props: FluentIconsProps) => {
    const styles = useStyles()

    return (
        <svg version="1.0" xmlns="http://www.w3.org/2000/svg" height="1rem" viewBox="0 0 130 130" preserveAspectRatio="xMidYMid meet" {...props}>
            <circle className={styles.st6} cx="63.7" cy="36.5" r="36.7" />
            <circle className={styles.st7} cx="94.3" cy="70" r="33.9" />
            <circle className={styles.st8} cx="68.5" cy="102.1" r="26" />
            <path
                className={styles.st9}
                d="M59.5,97.2h-53c-3.5,0-6.4-2.9-6.4-6.4V38.6c0-3.5,2.9-6.4,6.4-6.4h53c3.5,0,6.4,2.9,6.4,6.4v52.2  C65.9,94.3,63.1,97.2,59.5,97.2z"
            />
            <g>
                <path
                    className={styles.st5}
                    d="M22.3,75.9c2.1,1.2,5.4,2.3,8.8,2.3c4.2,0,6.6-2,6.6-4.9c0-2.7-1.8-4.3-6.4-6c-6-2.1-9.9-5.3-9.9-10.4   c0-5.9,5-10.3,12.9-10.3c3.9,0,6.8,0.9,8.7,1.8l-1.6,5.3C40.1,53,37.6,52,34.2,52c-4.2,0-6,2.2-6,4.3c0,2.8,2.1,4,7,5.9   c6.3,2.4,9.3,5.5,9.3,10.6c0,5.8-4.4,10.7-13.8,10.7c-3.9,0-7.9-1.1-9.9-2.2L22.3,75.9z"
                />
            </g>
            <path
                className={styles.st48}
                d="M65.9,38c0,0.2,0,0.4,0,0.6v52.2c0,3.5-2.9,6.4-6.4,6.4H42.8l-0.2,5.7h22.4c3.5,0,6.4-2.9,6.4-6.4V44.3  C71.3,41.1,69,38.5,65.9,38z"
            />
        </svg>
    )
}, 'SharePointIcon')
